export enum QuestionnaireItems {
	ACTUAL_WEIGHT = 'mothersHealth.actualWeight',
	WEIGHT_BEFORE_PREGNANCY = 'mothersHealth.weighBeforePregnancy',
	CTG = 'mothersHealth.ctg.value',
	SYSTOLIC_BLOOD_PRESSURE = 'mothersHealth.systolicBloodPressure',
	DIASTOLIC_BLOOD_PRESSURE = 'mothersHealth.diastolicBloodPressure',
	TOTAL_NUMBER_OF_PREGNANCIES = 'currentPregnancy.totalNumberOfPregnanciesIncludingCurrent',
	ADDITIONAL_WEIGHT = 'additionalWeightInPregnancy',
	URINE_PROTEIN = 'mothersHealth.urine.protein.value',
	URINE_GLUCOSE = 'mothersHealth.urine.glucose.value',
	URINE_BLOOD = 'mothersHealth.urine.blood',
	EDEMAS = 'mothersHealth.edemas',
	BODY_TEMPERATURE = 'mothersHealth.bodyTemperature',
	HOW_MANY_TIMES_PATIENT_USE_RESCUE_MEDICATION = 'howManyTimesPatientUseRescueMedication',
	PATIENT_SATISFACTION_WITH_TREATMENT = 'patientSatisfactionWithTreatment',
	CONNECTION_BETWEEN_PILLS_AND_PAIN = 'connectionBetweenPillsAndPain',
	BLOOD_PRESSURE = 'bloodPressure',
}
